export default __webpack_public_path__ + "static/media/Frame.a1ae5f45.svg";